import { shallowEqual, useSelector } from 'react-redux'
import { path } from 'ramda'

import usePagingExtended from 'app/common/hooks/usePagingExtended'
import { surveysSettingsKey } from 'app/reducers/settings/surveys'


export const useSurveysPagination = () => {
  const perPage = useSelector(
    path(['settings', surveysSettingsKey, 'rows']),
    shallowEqual,
  ) as number

  const {
    currentPage,
    offset,
    onPage,
    resetPagination,
  } = usePagingExtended(perPage)

  return {
    currentPage,
    currentPageIndex: currentPage - 1,
    offset,
    perPage,
    onPage,
    resetPagination,
  }
}
